import { apiRequest } from './client';
import { Chat, CreateChatRequest, UpdateChatRequest } from './types';

// Get all chats for authenticated user
export const getChats = async (token: string): Promise<Chat[]> => {
  return apiRequest<Chat[]>({
    endpoint: '/chats',
    method: 'GET',
    token,
  });
};

// Create a new chat
export const createChat = async (
  data: CreateChatRequest,
  token: string
): Promise<Chat> => {
  return apiRequest<Chat>({
    endpoint: '/chats',
    method: 'POST',
    body: data,
    token,
  });
};

// Update a specific chat
export const updateChat = async (
  chatId: string,
  data: UpdateChatRequest,
  token: string
): Promise<Chat> => {
  return apiRequest<Chat>({
    endpoint: `/chats/${chatId}`,
    method: 'PATCH',
    body: data,
    token,
  });
};

// Delete a specific chat
export const deleteChat = async (
  chatId: string,
  token: string
): Promise<void> => {
  return apiRequest<void>({
    endpoint: `/chats/${chatId}`,
    method: 'DELETE',
    token,
  });
};

